import React, { Component } from "react";
import { connect } from "react-redux";
import CommentInput from "./";
import { selectUser, selectCurrentPostId } from "../../../../../../util/selectors";
import { editComment } from "../../../../../../actions/commentActions";

class CommentInputEdit extends Component {
  constructor(props) {
    super(props);

    this.editComment = this.editComment.bind(this);
  }

  editComment() {
    const { postId, commentId } = this.props;
    return content => this.props.onSubmit({ postId, commentId, content });
  }
  componentDidMount() {
    this.CommentInputRef.focus();
  }
  render() {
    return (
      <CommentInput
        {...this.props}
        onSubmit={this.editComment()}
        getInputRef={input => (this.CommentInputRef = input)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: selectUser(state),
    postId: selectCurrentPostId(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: ({ postId, commentId, content }) => dispatch(editComment({ postId, commentId, content })),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentInputEdit);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentInput/CommentInputEdit.js